import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pie-piece",
  "use": "pie-piece-usage",
  "viewBox": "0 0 35 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 32\" id=\"pie-piece\"><defs><style>#pie-piece .cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><title>pie-piece</title><g id=\"pie-piece_Слой_2\" data-name=\"Слой 2\"><g id=\"pie-piece_icons\"><path class=\"cls-1\" d=\"M15.5,16l8.27,12.32A14.17,14.17,0,0,1,15.5,31C7.55,31,1,24.23,1,16S7.55,1,15.5,1,30,7.77,30,16Z\" /><path class=\"cls-1\" d=\"M22,19H34a12.28,12.28,0,0,1-1.37,5.65A12.11,12.11,0,0,1,28.82,29Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol